<template>
    <div id="mvp-offer">
        <section class="mvp-section" id="features">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="section-heading text-center">
                            <h5>The New Standard in How to Start a Start-Up</h5>
                            <h2>Wanna hear about a new way of developing apps by yourself?</h2>
                            <p class="mvp-p">The perfect solution to start your start-up and get high-impact business outcomes right away</p>
                            <button name="register-mvp-offer"
                                    class="btn mb10 mt-3 to-contact mx-auto d-block"
                                    v-scroll-to="'#contact'">Learn more</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'mvp-offer',
        computed: {
            ...mapGetters({
                mobile: 'layout/mobile',
            }),
        },
        methods: {
            ...mapActions({
                updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
            }),
        },
    }
</script>

<style lang="css" scoped>
    .section-heading {
        margin-bottom: 60px;
    }
    .section-heading > h2 {
        font-weight: 300;
        color: #fff;
        font-size: 40px;
        margin-bottom: 30px;
    }
    .section-heading h5 {
        font-weight: 300;
        color: #fff;
        font-size: 16px;
        margin-top: 30px;
    }
    .mvp-section{
        background-image: linear-gradient(144deg, rgba(40, 49, 59, 0.85) 10%, rgba(72, 84, 97, 0.85) 65%);
        min-height: 200px;
        padding-bottom: 20px;
        padding-top: 20px;
    }
    .mvp-p {
        font-size: 16px;
        color: #fff;
    }
    button.to-contact {
        background: linear-gradient(144deg, #7719b4 10%, #bf35d0 65%);
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
        margin-top: 30px !important;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .section-heading > h2 {
            font-size: 32px;
        }
    }
</style>
